// source: interpretation.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.com.royalhaskoningdhv.mondriaan.proto.InterpretationMethod', null, global);
/**
 * @enum {number}
 */
proto.com.royalhaskoningdhv.mondriaan.proto.InterpretationMethod = {
  MANUAL: 0,
  CUR: 1,
  ROBERTSON: 2,
  IC_TYPE: 3
};

goog.object.extend(exports, proto.com.royalhaskoningdhv.mondriaan.proto);
